import useSWR, { mutate } from "swr"
import { orderRepository } from "../repositories"

export const useRequestOrderMessages = (id: string) => {
  const fetcher = () => orderRepository.requestOrdersMessage(id)
  const { data, error, isValidating, mutate } = useSWR([`/request-orders/${id}/messages`], fetcher)

  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
    isValidating: isValidating,
    mutate
  }
}
